import { useRef, useState } from "react";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import rightArrow from "../assests/smlrightarrow.png";
import leftArrow from "../assests/smlleftArrow.png";
export default function ({ render, stateChanger, keyVal }) {
  const containerRef = useRef(null);
  const [index, setIndex] = useState();
  const scrollAmount = 150; // Adjust this value as needed

  const handleScrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollLeft -= scrollAmount;
    }
  };

  const handleScrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollLeft += scrollAmount;
    }
  };

  function lighterColor(color, percentage) {
    // Ensure the percentage is between 0 and 100
    percentage = Math.min(100, Math.max(0, percentage));

    // Convert the color to RGB format
    let r = parseInt(color.slice(1, 3), 16);
    let g = parseInt(color.slice(3, 5), 16);
    let b = parseInt(color.slice(5, 7), 16);

    // Calculate the new color values
    r += (255 - r) * (percentage / 100);
    g += (255 - g) * (percentage / 100);
    b += (255 - b) * (percentage / 100);

    // Convert the new RGB values back to hex format
    r = Math.round(r).toString(16).padStart(2, "0");
    g = Math.round(g).toString(16).padStart(2, "0");
    b = Math.round(b).toString(16).padStart(2, "0");

    return `#${r}${g}${b}`;
  }

  return (
    <div className="p-0 m-0">
      {/* <h5 className="font-bold">Heading of the color picker</h5> */}
      <div className="flex flex-row content-center">
        {render.length > 6 && (
          <button
            className="w-[30px] mb-8 bg-black rounded-full h-[30px] p-[4px] flex justify-center items-center mt-[20px]"
            onClick={handleScrollLeft}
          >
            {/* <img src={leftArrow} alt="Right Arrow" /> */}
            <span className="transition-transform duration-300 hover:scale-110">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </span>
          </button>
        )}
        <ul
          className={`w-[450px] flex flex-row px-[3px] py-[5px] custom-scrollbar ${render.length > 6 && 'overflow-x-scroll'} ${render.length < 7 && 'ml-8'}`}
          ref={containerRef}
        >
          {render?.map((val, ind) => (
            <li
              className="mx-3 transition-transform duration-300 hover:scale-110"
              onClick={() => {
                stateChanger(keyVal, val.color);
                setIndex(ind);
              }}
            >
              <div
                key={ind}
                // className={`w-[50px] aspect-[1/1] rounded-[50px] cursor-pointer bg-gradient-to-r from-${val.color} via-white to-${val.color} shadow-inner-md ${
                //   index === ind ? "border-2 border-[#00FFFF]" : ""
                // }`}
                style={{
                  width: "50px",
                  aspectRatio: "1/1",
                  borderRadius: "50px",
                  cursor: "pointer",
                  background: `linear-gradient(139deg, ${
                    val.color2 ? val.color2 : val.color
                  } 14.83%, ${lighterColor(val.color, 40)} 44.08%, ${
                    val.color2 ? val.color2 : val.color
                  } 88.5%)`, // Adjust the percentage as needed
                  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset",
                }}
                //style={{ backgroundColor: val.color2 ? val.color2 : val.color }}
              ></div>
              <p className="text-center text-[12px] mt-1">{val.title}</p>
            </li>
          ))}
        </ul>
        {render.length > 6 && (
          <button
            className="w-[30px] mb-8 bg-black rounded-full h-[30px] p-[4px] flex justify-center items-center mt-[20px]"
            onClick={handleScrollRight}
          >
            {/* <img src={rightArrow} alt="Right Arrow" /> */}
            <span className="transition-transform duration-300 hover:scale-110">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M9 18l6-6-6-6" />
              </svg>
            </span>
          </button>
        )}
      </div>
    </div>
  );
}
